import { post } from '../../utils/http/http'
import { SHOP_URL } from '../../utils/http/baseUrl'

export default {
  // 查询用户地址详细列表或指定地址记录
  address: params => post(`${SHOP_URL}/api/address/address`, params, false),
  // 查询用户当前使用的默认地址
  default_address: params =>
    post(`${SHOP_URL}/api/address/default_address`, params, false),
  // 保存收货地址信息
  save_address: params =>
    post(`${SHOP_URL}/api/address/save_address`, params, false),
  // 删除收货地址记录
  del_address: params =>
    post(`${SHOP_URL}/api/address/del_address?id=${params.id}`, params, false)
}
